import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTextosPDF, modificarTextoPDF } from "../../actions/configFormularioAction";
import { esborrarErrorAction, esborrarOkAction } from "../../actions/ui";

// ── Iconos ────────────────────────────────────────────────────────────────────
const IconChevDown = ({ open }) => (
    <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
        style={{ transition:'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink:0 }}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
    </svg>
);
const IconSave = () => (
    <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V7l-4-4zm-5 16a3 3 0 110-6 3 3 0 010 6zm3-10H5V5h10v4z"/>
    </svg>
);
const IconTag = () => (
    <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z"/>
    </svg>
);

// Variables disponibles para insertar en el texto
// Variables globales (disponibles en todos los niveles)
const VARIABLES_GLOBAL = [
    { label: '[NombreMunicipio]',    desc: 'Nombre del municipio' },
    { label: '[ResultadoCategoria]', desc: 'Resultado de la categoría' },
    { label: '[ResultadoFinal]',     desc: 'Resultado final global' },
];

// Variables extra solo para textos de pregunta
const VARIABLES_PREGUNTA = [
    { label: '[ResultadoPregunta]',  desc: 'Resultado obtenido en esta pregunta' },
    { label: '[ConstantePregunta]',  desc: 'Valor constante (peso) asignado a esta pregunta' },
    { label: '[ValorPregunta]',      desc: 'Valor introducido por el municipio en esta pregunta' },
];

// Colores por nivel
const NIVEL_COLORS = {
    1: { bg:'#eff6ff', border:'#bfdbfe', color:'#1d4ed8', dot:'#3b82f6' }, // Excelente - azul
    2: { bg:'#f0fdf4', border:'#bbf7d0', color:'#15803d', dot:'#22c55e' }, // Bueno - verde
    3: { bg:'#fffbeb', border:'#fde68a', color:'#92400e', dot:'#f59e0b' }, // A mejorar - amarillo
    4: { bg:'#fef2f2', border:'#fecaca', color:'#991b1b', dot:'#ef4444' }, // Mal - rojo
};

const getNivelColors = (nivel) => NIVEL_COLORS[nivel] || { bg:'#f9fafb', border:'#e5e7eb', color:'#374151', dot:'#9ca3af' };

export const FormularioPDFAdmin = () => {
    const dispatch  = useDispatch();
    const { auth, configFormulario, ui } = useSelector(s => s);
    const { msgOk, msgError } = ui;
    const textosPDF           = configFormulario?.textosPDF;
    const textosCat           = configFormulario?.infoFormularioTextCategoria; // para títulos

    const [catAbierta,    setCatAbierta]    = useState(null); // 'resultado_final' | 'cat_1' | ...
    const [pregAbierta,   setPregAbierta]   = useState(null); // key de pregunta
    const [catColapsada,  setCatColapsada]  = useState(false); // colapsar textos cat al abrir preg

    useEffect(() => {
        if (!textosPDF) dispatch(getTextosPDF(auth.tokenJwt));
    }, []);

    useEffect(() => {
        if (msgError) setTimeout(() => dispatch(esborrarErrorAction()), 8000);
        if (msgOk)    setTimeout(() => dispatch(esborrarOkAction()),    4000);
    }, [ui]);

    if (!textosPDF) return <div style={css.emptyState}>Cargando textos PDF...</div>;

    const { niveles, resultado_final, categorias, preguntas } = textosPDF;
    const nivelesArray = Object.entries(niveles || {}).map(([n, l]) => ({ nivel: parseInt(n), label: l }));

    return (
        <div>
            {/* Cabecera */}
            <div style={{ marginBottom: 24 }}>
                <p style={css.labelSuper}>Administración</p>
                <h2 style={css.h2}>Textos PDF</h2>
                <p style={css.subText}>Edita los textos que se usarán al generar el PDF de evaluación</p>
            </div>

            {/* Leyenda variables */}
            <div style={{ marginBottom: 20, padding:'12px 16px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10 }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:8 }}>
                    <IconTag />
                    <span style={{ fontSize:12, fontWeight:700, color:'#475569', textTransform:'uppercase', letterSpacing:'0.06em' }}>Variables disponibles</span>
                </div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                    {[...VARIABLES_GLOBAL, ...VARIABLES_PREGUNTA].map(v => (
                        <span key={v.label} title={v.desc} style={{ padding:'3px 10px', borderRadius:20, background: VARIABLES_PREGUNTA.includes(v) ? '#f0fdf4' : '#e0f2fe', color: VARIABLES_PREGUNTA.includes(v) ? '#15803d' : '#0369a1', fontSize:12, fontWeight:600, cursor:'default', fontFamily:'monospace' }}>
                            {v.label}
                        </span>
                    ))}
                </div>
                <p style={{ fontSize:11, color:'#94a3b8', margin:'6px 0 0' }}>Variables en <span style={{color:'#0369a1',fontWeight:600}}>azul</span>: disponibles en todos los textos. En <span style={{color:'#15803d',fontWeight:600}}>verde</span>: solo en textos de pregunta.</p>
            </div>

            {msgError && <div style={{ ...css.alert, background:'#fef2f2', borderColor:'#fecaca', color:'#dc2626', marginBottom:16 }}>{msgError}</div>}
            {msgOk    && <div style={{ ...css.alert, background:'#f0fdf4', borderColor:'#bbf7d0', color:'#15803d', marginBottom:16 }}>{msgOk}</div>}

            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>

                {/* ── Resultado Final ── */}
                <AccordionSection
                    id="resultado_final"
                    isOpen={catAbierta === 'resultado_final'}
                    onToggle={() => { setCatAbierta(catAbierta === 'resultado_final' ? null : 'resultado_final'); setPregAbierta(null); }}
                    badge="★"
                    titulo="Resultado Final"
                >
                    <NivelesTexto
                        nivelesArray={nivelesArray}
                        datos={resultado_final}
                        token={auth.tokenJwt}
                        dispatch={dispatch}
                    />
                </AccordionSection>

                {/* ── Categorías 1-9 ── */}
                {Array.from({ length: 9 }, (_, i) => i + 1).map(catIndex => {
                    const titulo    = textosCat?.[`Categoria${catIndex}`]?.[`Cat${catIndex}_Titol`] || `Categoría ${catIndex}`;
                    const catKey    = `cat_${catIndex}`;
                    const isOpenCat = catAbierta === catKey;
                    const pregsCat  = preguntas?.[catIndex] || {};
                    const numPregs  = Object.keys(pregsCat).length;

                    return (
                        <AccordionSection
                            key={catIndex}
                            id={catKey}
                            isOpen={isOpenCat}
                            onToggle={() => { setCatAbierta(isOpenCat ? null : catKey); setPregAbierta(null); }}
                            badge={catIndex}
                            titulo={titulo}
                            subInfo={`${numPregs} preguntas`}
                        >
                            {/* Texto de categoría — se colapsa al abrir una pregunta */}
                            <div style={{ marginBottom: 20 }}>
                                <button
                                    onClick={() => setCatColapsada(v => !v)}
                                    style={{ display:'flex', alignItems:'center', gap:6, background:'none', border:'none', cursor:'pointer', padding:'4px 0', marginBottom: catColapsada ? 0 : 10 }}
                                >
                                    <span style={{ fontSize:12, fontWeight:700, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>
                                        Texto de categoría
                                    </span>
                                    <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
                                        style={{ transition:'transform 0.2s', transform: catColapsada ? 'rotate(-90deg)' : 'rotate(0deg)', color:'#9ca3af' }}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
                                    </svg>
                                </button>
                                {!catColapsada && (
                                    <NivelesTexto
                                        nivelesArray={nivelesArray}
                                        datos={categorias?.[catIndex]}
                                        token={auth.tokenJwt}
                                        dispatch={dispatch}
                                    />
                                )}
                            </div>

                            {/* Preguntas */}
                            {numPregs > 0 && (
                                <div>
                                    <p style={{ fontSize:12, fontWeight:700, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:8 }}>
                                        Indicadores
                                    </p>
                                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                                        {Object.keys(pregsCat).sort((a,b) => a-b).map(pregNum => {
                                            const pregKey  = `${catKey}_preg_${pregNum}`;
                                            const isOpenPr = pregAbierta === pregKey;
                                            // Título de la pregunta desde Dic_Textos
                                            const tituloPr = textosCat?.[`Categoria${catIndex}`]?.[`Cat${catIndex}_Preg${pregNum}`] || `Pregunta ${pregNum}`;
                                            return (
                                                <div key={pregNum} style={{ border:`1.5px solid ${isOpenPr?'#374151':'#f3f4f6'}`, borderRadius:9, overflow:'hidden', background:'#fff' }}>
                                                    <button
                                                        onClick={() => setPregAbierta(isOpenPr ? null : pregKey)}
                                                        style={{ width:'100%', display:'flex', alignItems:'center', gap:10, padding:'10px 16px', background:'none', border:'none', cursor:'pointer', textAlign:'left' }}
                                                        onMouseEnter={e => !isOpenPr && (e.currentTarget.style.background='#f9fafb')}
                                                        onMouseLeave={e => !isOpenPr && (e.currentTarget.style.background='none')}
                                                    >
                                                        <span style={{ width:22, height:22, borderRadius:6, background: isOpenPr?'#374151':'#f3f4f6', color: isOpenPr?'#fff':'#6b7280', display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, flexShrink:0 }}>
                                                            {pregNum}
                                                        </span>
                                                        <span style={{ fontSize:13, color: isOpenPr?'#111827':'#374151', fontWeight: isOpenPr?600:400, flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                                                            {tituloPr}
                                                        </span>
                                                        <IconChevDown open={isOpenPr} />
                                                    </button>
                                                    {isOpenPr && (
                                                        <div style={{ borderTop:'1px solid #f3f4f6', padding:'14px 16px' }}>
                                                            <NivelesTexto
                                                                nivelesArray={nivelesArray}
                                                                datos={pregsCat[pregNum]}
                                                                token={auth.tokenJwt}
                                                                dispatch={dispatch}
                                                                esPregunta={true}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </AccordionSection>
                    );
                })}
            </div>
        </div>
    );
};

// ── Sub-componente: sección acordeón de categoría ─────────────────────────────
const AccordionSection = ({ id, isOpen, onToggle, badge, titulo, subInfo, children }) => (
    <div style={{ ...css.accordion, borderColor: isOpen ? '#111827' : '#e5e7eb' }}>
        <button
            onClick={onToggle}
            style={css.accordionHeader}
            onMouseEnter={e => !isOpen && (e.currentTarget.style.background='#f9fafb')}
            onMouseLeave={e => !isOpen && (e.currentTarget.style.background='#fff')}
        >
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <span style={{ ...css.catBadge, background: isOpen?'#111827':'#f3f4f6', color: isOpen?'#fff':'#6b7280' }}>
                    {badge}
                </span>
                <div>
                    <span style={{ fontSize:14, fontWeight:600, color: isOpen?'#111827':'#374151', textTransform:'uppercase', letterSpacing:'0.04em' }}>
                        {titulo}
                    </span>
                    {subInfo && <span style={{ fontSize:12, color:'#9ca3af', marginLeft:8 }}>{subInfo}</span>}
                </div>
            </div>
            <IconChevDown open={isOpen} />
        </button>
        {isOpen && (
            <div style={{ borderTop:'1px solid #f3f4f6', padding:'20px 24px' }}>
                {children}
            </div>
        )}
    </div>
);

// ── Sub-componente: niveles de valoración con su textarea ───────────────────
const NivelesTexto = ({ nivelesArray, datos, token, dispatch, esPregunta = false }) => {
    const variables = esPregunta ? [...VARIABLES_GLOBAL, ...VARIABLES_PREGUNTA] : VARIABLES_GLOBAL;
    // Estado local para edición antes de guardar
    const [textos, setTextos] = useState({});

    useEffect(() => {
        if (!datos || !nivelesArray.length) return;
        // Las claves que vienen del PHP son strings, usar String(nivel) para acceder
        const init = {};
        nivelesArray.forEach(({ nivel }) => {
            init[nivel] = datos?.[String(nivel)]?.Texto ?? '';
        });
        setTextos(init);
    }, [datos, nivelesArray]);

    const handleGuardar = (nivel) => {
        const entrada = datos?.[String(nivel)];
        if (!entrada) return;
        dispatch(modificarTextoPDF(token, entrada.IdTextoPDF, textos[nivel]));
    };

    const insertarVariable = (nivel, variable) => {
        setTextos(prev => ({ ...prev, [nivel]: (prev[nivel] || '') + variable }));
    };

    return (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {nivelesArray.map(({ nivel, label }) => {
                const colors  = getNivelColors(nivel);
                const entrada = datos?.[String(nivel)];
                const changed  = String(textos[nivel] ?? '') !== String(entrada?.Texto ?? '');
                return (
                    <div key={nivel} style={{ border:`1.5px solid ${colors.border}`, borderRadius:10, overflow:'hidden' }}>
                        {/* Header nivel */}
                        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 14px', background:colors.bg }}>
                            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                                <span style={{ width:8, height:8, borderRadius:'50%', background:colors.dot, flexShrink:0 }} />
                                <span style={{ fontSize:13, fontWeight:700, color:colors.color }}>{label}</span>
                            </div>
                            {/* Botones variables */}
                            <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
                                {variables.map(v => (
                                    <button
                                        key={v.label}
                                        onClick={() => insertarVariable(nivel, v.label)}
                                        title={v.desc}
                                        style={{ padding:'2px 8px', borderRadius:12, fontSize:10, fontWeight:600, background:'rgba(255,255,255,0.7)', color:'#0369a1', border:'1px solid #bae6fd', cursor:'pointer', fontFamily:'monospace' }}
                                    >
                                        {v.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                        {/* Textarea */}
                        <div style={{ padding:'10px 14px', background:'#fff' }}>
                            <textarea
                                value={textos[nivel] || ''}
                                onChange={e => setTextos(prev => ({ ...prev, [nivel]: e.target.value }))}
                                rows={3}
                                placeholder={`Escribe el texto para el nivel "${label}"... Usa las variables para personalizar.`}
                                style={{ width:'100%', padding:'8px 10px', fontSize:13, border:`1.5px solid ${changed?'#f59e0b':'#e5e7eb'}`, borderRadius:7, outline:'none', resize:'vertical', color:'#111827', background: changed?'#fffbeb':'#fff', boxSizing:'border-box', fontFamily:'inherit', lineHeight:1.5 }}
                            />
                            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:6 }}>
                                <button
                                    onClick={() => handleGuardar(nivel)}
                                    disabled={!changed}
                                    style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'6px 14px', borderRadius:7, fontSize:13, fontWeight:600, background: changed?'#111827':'#f3f4f6', color: changed?'#fff':'#9ca3af', border:'none', cursor: changed?'pointer':'not-allowed', transition:'all 0.15s' }}
                                >
                                    <IconSave /> Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

// ── Design tokens ─────────────────────────────────────────────────────────────
const css = {
    labelSuper:      { fontSize:11, fontWeight:600, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.08em', margin:'0 0 6px' },
    h2:              { fontSize:26, fontWeight:700, color:'#111827', margin:0 },
    subText:         { fontSize:14, color:'#6b7280', margin:'4px 0 0' },
    alert:           { padding:'11px 15px', borderRadius:9, fontSize:13, border:'1px solid', fontWeight:500 },
    accordion:       { background:'#fff', borderRadius:12, border:'1.5px solid #e5e7eb', overflow:'hidden' },
    accordionHeader: { width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 20px', background:'#fff', border:'none', cursor:'pointer', textAlign:'left', transition:'background 0.15s' },
    catBadge:        { width:28, height:28, borderRadius:8, display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, flexShrink:0 },
    emptyState:      { textAlign:'center', padding:'60px 0', color:'#9ca3af' },
};
